import { createIconComponent } from '../../factory/create-icon-component';
export const AssortmentEditIcon = createIconComponent(
  'AssortmentEditIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.00073 3.99957C6.00073 5.10414 5.1053 5.99957 4.00073 5.99957C2.89616 5.99957 2.00073 5.10414 2.00073 3.99957C2.00073 2.895 2.89616 1.99957 4.00073 1.99957C5.1053 1.99957 6.00073 2.895 6.00073 3.99957Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="4.00073"
      cy="19.9996"
      r="2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="12.0008"
      cy="3.99957"
      r="2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="12.0008"
      cy="11.9996"
      r="2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="4.00073"
      cy="11.9996"
      r="2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0008 21.9996C10.8962 21.9996 10.0008 21.1041 10.0008 19.9996C10.0008 19.2596 10.4026 18.6135 11 18.2676"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.0007 11.9996C22.0007 10.8951 21.1053 9.99963 20.0007 9.99963C18.8962 9.99963 18.0007 10.8951 18.0007 11.9996"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="20.0007"
      cy="3.99957"
      r="2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 16L16.8702 18.1298L16.8702 18.1298C16.3609 18.6391 16.1063 18.8937 15.9039 19.1839C15.7243 19.4414 15.5757 19.7192 15.461 20.0114C15.3319 20.3407 15.2612 20.6939 15.12 21.4001L15 22L15.5999 21.88C16.3061 21.7388 16.6593 21.6681 16.9886 21.539C17.2808 21.4243 17.5586 21.2757 17.8161 21.0961C18.1063 20.8937 18.3609 20.6391 18.8702 20.1298L21 18C21.5523 17.4477 21.5523 16.5523 21 16C20.4477 15.4477 19.5523 15.4477 19 16Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
